import type { SxProps, Theme } from '@mui/material/styles';
import { button } from '@/shared/theme/tokens';

const toolbarButtonHeight = {
  boxSizing: 'border-box' as const,
  height: button.height,
  minHeight: button.height,
};

/**
 * Toolbar actions use the default button token (32px), including when a
 * button is `size="small"` (28px). Icon buttons stay square at the same size.
 * Controls inside a field (clear, picker, autocomplete) keep their own size.
 */
export const toolbarActionsSx: SxProps<Theme> = {
  // `&&` beats theme size slots (small is 28px) so toolbar actions stay 32px.
  '&& .MuiButton-root': {
    ...toolbarButtonHeight,
    paddingTop: 0,
    paddingBottom: 0,
  },
  '&& .MuiIconButton-root': {
    ...toolbarButtonHeight,
    width: button.height,
    padding: 0,
  },
  '& .MuiToggleButtonGroup-root': {
    height: button.height,
    minHeight: button.height,
  },
  '& .MuiToggleButton-root.MuiToggleButton-root': {
    ...toolbarButtonHeight,
    py: 0,
  },
  '& .MuiInputBase-root .MuiButton-root, & .MuiInputBase-root .MuiIconButton-root, & .MuiPickersInputBase-root .MuiButton-root, & .MuiPickersInputBase-root .MuiIconButton-root, & .MuiPickersOutlinedInput-root .MuiButton-root, & .MuiPickersOutlinedInput-root .MuiIconButton-root, & .MuiAutocomplete-root .MuiButton-root, & .MuiAutocomplete-root .MuiIconButton-root':
    {
      height: 'unset',
      minHeight: 'unset',
      width: 'unset',
      padding: 'unset',
    },
};
